import { render, staticRenderFns } from "./RealityModal.vue?vue&type=template&id=3f2e01ea&scoped=true&"
import script from "./RealityModal.vue?vue&type=script&lang=js&"
export * from "./RealityModal.vue?vue&type=script&lang=js&"
import style0 from "./RealityModal.vue?vue&type=style&index=0&id=3f2e01ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e01ea",
  null
  
)

export default component.exports